import { render, staticRenderFns } from "./ExpandableContent.vue?vue&type=template&id=9c99e53e&"
import script from "./ExpandableContent.vue?vue&type=script&lang=ts&"
export * from "./ExpandableContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports